import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/contractor/$contractorId/resources/')({
  loader: ({ params }) => {
    redirect({
      to: '/contractor/$contractorId/resources/machines',
      params: { contractorId: params.contractorId },
      throw: true,
    })
  },
})
